import { useAddressSearch } from '@gov-nx/core/hooks';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useProfilROBReklamaceContextInstance } from '@gov-nx/module/page';
import { Button, FormInput, FormSelect } from '@gov-nx/ui/web';

export interface DeliveryAddressFormProps {
	code: PageCode;
	isProcessing: boolean;
}

export const DeliveryAddressSearchForm = ({
	code,
	isProcessing,
}: DeliveryAddressFormProps) => {
	const {
		deliveryAddress,
		deliveryAddressQuery,
		formDefinition,
		setControls,
		controls,
	} = useProfilROBReklamaceContextInstance();
	const { form } = formDefinition;
	const { disableDeliveryAddressSearchButton } = useAddressSearch({
		formMethods: form.formMethods,
	});
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const ts = getLocalizeCurried(code);

	return (
		<>
			<FormInput {...form.fields.nazevObceDorucovaciAdresa} />
			<FormInput {...form.fields.nazevUliceDorucovaciAdresa} />
			<FormInput {...form.fields.cisloDorucovaciAdresa} />
			<Button
				onClick={() => {
					deliveryAddressQuery.refetch();
					setControls({ displaySearchDeliveryAddressLoading: true });
				}}
				isDisabled={disableDeliveryAddressSearchButton || isProcessing}
				isLoading={controls.displaySearchDeliveryAddressLoading}
				nativeType="button"
				color="primary"
				size="m"
				type="outlined">
				{ts('akce.vyhledat')}
			</Button>
			{deliveryAddressQuery.isSuccess && (
				<FormSelect
					{...form.fields.newDeliveryAddress}
					field={{
						...form.fields.newDeliveryAddress.field,
						children: (
							<>
								<option
									value=""
									disabled>
									{ts('formular.pole.neuvedeno')}
								</option>
								<option value={ts('formular.adresa.neni-evidovana')}>
									{ts('formular.adresa.neni-evidovana')}
								</option>
								{deliveryAddress.map((address) => (
									<option
										value={address.kod}
										key={address.kod}>
										{address.adresaText}
									</option>
								))}
							</>
						),
					}}
				/>
			)}
		</>
	);
};
